import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export type { MuiBoxProps as BoxProps };

const Box = MuiBox;

export default Box;
